import { Component, Input } from '@angular/core';
import { RbacService } from '../../../auth/_services/rbac.service';

@Component({
    standalone: false,
    selector: 'app-tenant-navigation',
    template: `
        <nav class="tenant-navigation" aria-label="Tenant navigation">
            <div class="tenant-navigation__identity"><span class="tenant-navigation__eyebrow">TENANT WORKSPACE</span><strong>{{tenantName || tenantId}}</strong><small *ngIf="tenantName">{{tenantId}}</small></div>
            <div class="tenant-navigation__links">
                <a [routerLink]="base" [queryParams]="{view: 'overview'}" [class.active]="active === 'overview'" [attr.aria-current]="active === 'overview' ? 'page' : null">Overview</a>
                <a [routerLink]="base" [queryParams]="{view: 'services'}" [class.active]="active === 'services'" [attr.aria-current]="active === 'services' ? 'page' : null">PASSPOINT services</a>
                <a *ngIf="rbac.canReadTenantRadiusClients()" [routerLink]="base" [queryParams]="{view: 'radius'}" [class.active]="active === 'radius'" [attr.aria-current]="active === 'radius' ? 'page' : null">Passpoint RADIUS clients</a>
                <a *ngIf="rbac.canReadTenantRadiusClients()" [routerLink]="['/administration/tenants', tenantId, 'email-templates']" [class.active]="active === 'templates'" [attr.aria-current]="active === 'templates' ? 'page' : null">Email templates</a>
            </div>
        </nav>`,
    styles: [`
        .tenant-navigation { background:#fff; border:1px solid #ebedf2; border-radius:10px; margin-bottom:24px; overflow:hidden; }
        .tenant-navigation__identity { display:flex; flex-wrap:wrap; align-items:baseline; gap:12px; padding:20px 24px; }
        .tenant-navigation__eyebrow { font-size:10px; letter-spacing:1.2px; color:#74788d; font-weight:600; }
        .tenant-navigation__identity strong { font-size:18px; color:#282a3c; }
        .tenant-navigation__identity small { color:#74788d; }
        .tenant-navigation__links { display:flex; gap:4px; flex-wrap:wrap; padding:0 16px; border-top:1px solid #f0f1f5; }
        .tenant-navigation__links a { padding:15px 12px; border-bottom:3px solid transparent; color:#575962; text-decoration:none; font-weight:500; }
        .tenant-navigation__links a.active { color:#5867dd; border-bottom-color:#5867dd; background:#f8f9ff; }
        .tenant-navigation__links a:hover { background:#f8f9fb; }
        .tenant-navigation__links a:focus-visible { outline:2px solid #5867dd; outline-offset:-3px; }
        @media(max-width:575px) { .tenant-navigation__identity {padding:16px;} .tenant-navigation__links {padding:0 4px;} .tenant-navigation__links a {padding:12px 8px;} }
    `]
})
export class TenantNavigationComponent {
    @Input() tenantId = '';
    @Input() tenantName = '';
    @Input() active: 'overview' | 'services' | 'radius' | 'templates' = 'overview';
    constructor(public rbac: RbacService) {}
    get base() { return ['/administration/tenants', this.tenantId, 'services']; }
}
